import React from "react";

import { Link } from "react-router-dom";

import { useAuth } from "./../../hooks/auth";
import { FaFileAlt } from "react-icons/fa";

import {
  Container,
  Content,
  LoginContainer,
  About7CantosContainer,
  UserRoutesContainer,
  FirstOptionsContainer,
  SecondOptionsContainer,
  RoutesContainer,
  SettingsContainer,
} from "./styles";

import { FaHeart, FaCalendarAlt } from "react-icons/fa";
import { GiWallet } from "react-icons/gi";
import { BiX } from "react-icons/bi";

import clube7CantosImg from "./../../assets/components/Menu/7-cantos.png";
import logo7cantosImg from "./../../assets/components/Menu/7-cantos-logo.png";

import CreditCardIcon from "./../../assets/components/Menu/creditCardIcon.svg";
import PaperIcon from "./../../assets/components/Menu/paper.png";
import { VscChecklist } from "react-icons/vsc";
import { MdDashboard } from "react-icons/md";
import DecorImage from "../../assets/components/Menu/7Cantos_Decor.svg";

interface IMenuInquilinoToMobile {
  functionToCloseMenuInquilinoToMobile(): void;
}

export default function MenuInquilinoToMobile({
  functionToCloseMenuInquilinoToMobile,
}: IMenuInquilinoToMobile) {
  const { user, logOut } = useAuth();
  const isAdminUser =
    user?.type === "admin" ||
    user?.role === "admin" ||
    user?.is_admin === true ||
    user?.isAdmin === true;

  return (
    <Container>
      <Content>
        <button onClick={functionToCloseMenuInquilinoToMobile}>
          <BiX size={32} color="#FFF" />
        </button>

        <LoginContainer>
          {!user && (
            <>
              <h2>ACESSE SUA CONTA</h2>

              <Link
                to={{
                  pathname: "/login",
                  state: { fromSite: true },
                }}
              >
                ENTRAR
              </Link>
            </>
          )}

          {!!user && <h2>Olá, {user.first_name}</h2>}
        </LoginContainer>

        <hr />

        <About7CantosContainer>
          {isAdminUser && (
            <Link to="/style-guide" onClick={functionToCloseMenuInquilinoToMobile}>
              <p>Guia de estilo</p>
            </Link>
          )}
          <Link to="/about-us">
            <img src={logo7cantosImg} alt="logo7cantosImg" />
            <p>Sobre a 7Cantos</p>
          </Link>

          <a href="https://decor.7cantos.com/">
            <img src={DecorImage} alt="7Cantos_Decor" className="logo-7decor" />
            <p>Sobre a 7Decor</p>
          </a>
        </About7CantosContainer>

        <hr />

        <UserRoutesContainer>
          {!!user && <h3>INQUILINO</h3>}

          <RoutesContainer>
            <FirstOptionsContainer>
              <Link
                to={
                  !!user
                    ? "/favorites"
                    : {
                        pathname: "/login",
                        state: { fromSite: true },
                      }
                }
              >
                <FaHeart size={28} color="#FFF" />
                <p>Meus Favoritos</p>
              </Link>

              <Link
                to={
                  !!user
                    ? "/scheduled-visits"
                    : {
                        pathname: "/login",
                        state: { fromSite: true },
                      }
                }
              >
                <FaCalendarAlt size={28} color="#FFF" />
                <p>Visitas Agendadas</p>
              </Link>
            </FirstOptionsContainer>

            <SecondOptionsContainer>
              <Link
                to={
                  !!user
                    ? "/proposals"
                    : {
                        pathname: "/login",
                        state: { fromSite: true },
                      }
                }
              >
                <GiWallet size={28} color="#FFF" />
                <p>Propostas Enviadas</p>
              </Link>
              <Link
                to={
                  !!user
                    ? "/schedule-process"
                    : {
                        pathname: "/login",
                        state: { fromSite: true },
                      }
                }
              >
                <VscChecklist size={28} color="#FFF" />
                <p>Acompanhar Locação</p>
              </Link>
            </SecondOptionsContainer>
            <SecondOptionsContainer>
              <Link to={"/tenant-dashboard"}>
                <MdDashboard size={27} color="#FFF" />
                <p>Área do {!!user ? "Locatário" : "Cliente"}</p>
              </Link>

              <Link
                to={
                  !!user
                    ? "/user-documents"
                    : {
                        pathname: "/login",
                        state: { fromSite: true },
                      }
                }
              >
                <FaFileAlt size={27} color="#FFF" />
                <p>Meus Documentos</p>
              </Link>
            </SecondOptionsContainer>
            <SecondOptionsContainer>
              {!!user && (
                <>
                  <Link
                    to={
                      !!user
                        ? "/request-termination"
                        : {
                            pathname: "/login",
                            state: { fromSite: true },
                          }
                    }
                  >
                    <img src={PaperIcon} alt="paper-icon" />
                    <p>Rescisão de Contrato</p>
                  </Link>
                </>
              )}
            </SecondOptionsContainer>
          </RoutesContainer>
        </UserRoutesContainer>

        <hr />

        {!!user && (
          <SettingsContainer>
            {/*<Link to="/settings">CONFIGURAÇÕES</Link>*/}
            <Link to="/me">Editar Perfil</Link>

            <button onClick={logOut}>Sair</button>
          </SettingsContainer>
        )}
      </Content>
    </Container>
  );
}
